module.exports = __webpack_public_path__ + "static/img/banner_new3.5af5979.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/banner/banner_new3.jpg
// module id = T0rb
// module chunks = 0